export const DEFAULT_AD_SCAN_HITS = 1000
